import React, { useState } from "react";

import { useDispatch } from "react-redux";
import { LoginAction, clearUserAction } from "../../redux/action/user";
import { baseURL } from "../../constants/pathnames";
import axios from "axios";

import Input from "../Input/Input";
import Button from "../Button/Button";
import "./login.sass";

const Login = (props) => {
  const [username, setUsername] = useState("");
  const [usernameError, setUsernameError] = useState("");

  const [password, setPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");

  const [passwordShown, setPasswordShown] = useState(false);
  const [globalerror, setGlobalError] = useState("");

  const [loading, setLoading] = useState(false);

  const { history } = props;
  const dispatch = useDispatch();

  const togglePasswordVisiblity = () => {
    setPasswordShown(passwordShown ? false : true);
  };

  const handleLogin = () => {
    debugger;
    dispatch(clearUserAction());
    if (username === "") {
      setUsernameError("لطفا نام کاربری را وارد کنید.");
    } else if (password === "") {
      setPasswordError("لطفا رمز عبور را وارد کنید.");
    } else {
      const data = { username: username, password: password };
      setLoading(true);
      axios
        .post(`${baseURL}auth/panel/login/`, data)
        .then(async (res) => {
          console.log("res! USER_VERIFY", res);
          await dispatch(LoginAction(res.data));
          setLoading(false);
          history.replace("/");
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
          if (
            err.response?.data?.non_field_errors[0] ===
            "Unable to log in with provided credentials."
          ) {
            setGlobalError("نام کاربری یا رمز عبور اشتباه است.");
          }
          console.log("login error: ", err?.response?.data);
        });

      // dispatch(clearUserAction(data));
      // history.replace("/dashboard");
    }
  };

  return (
    <div className='login-panel relative h-screen'>
      <div className='absolute inset-y-0 inset-x-0 m-auto max-w-2xl h-96 rounded-lg'>
        <div className='grid grid-cols-3 h-full rounded-lg'>
          <div className='login col-span-3 md:col-span-2 p-8 md:rounded-r-lg'>
            <div className='text-center text-xl'>به چنجش کن خوش آمدید!</div>

            <Input
              title='نام کاربری'
              placeholder='نام کاربری'
              maxWidth='100%'
              value={username}
              error={usernameError}
              type='text'
              autoComplete='off'
              input
              onChange={(event) => {
                let { value } = event.target;
                setUsername(value);
                setUsernameError("");
              }}
              onKeyUp={(e) => {
                if (e.keyCode === 13) {
                  handleLogin();
                }
              }}
            />

            <div className='relative w-full'>
              <Input
                title='کلمه عبور'
                placeholder='کلمه عبور'
                maxWidth='100%'
                value={password}
                error={passwordError}
                type={passwordShown ? "text" : "password"}
                autoComplete='off'
                input
                onChange={(event) => {
                  let { value } = event.target;
                  setPassword(value);
                  setPasswordError("");
                }}
                onKeyUp={(e) => {
                  if (e.keyCode === 13) {
                    handleLogin();
                  }
                }}
              />
              <div className='absolute z-50 top-1/2 left-3 cursor-pointer'>
                <img
                  onClick={togglePasswordVisiblity}
                  className='mx-1'
                  src='/statics/images/eye.png'
                  width='20'
                  height='20'
                  alt='eye'
                />
              </div>
            </div>

            <div>
              جهت تماس با پشتیبانی با شماره 02122334455 در ارتباط باشید{" "}
            </div>
            <Button
              title='ورود'
              onClick={() => {
                handleLogin();
              }}
              loading={loading}
            />
            <div className='font-12 text-red-800 h-12'>{globalerror}</div>
          </div>

          <div className='hidden md:flex flex-col justify-center items-center font-semibold w-full bg-white  md:rounded-l-lg'>
            <img
              className='m-2 max-w-xs'
              src='/statics/images/logo2.svg'
              alt='logo'
              onClick={() => {
                // history.goBack();
              }}
            />
            <div>چنجش کن</div>
            <div>مبادله کالا به کالا</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
